<div class="flex flex-col gap-6">
  <span class="text-[18px] font-bold">Impacto y evaluacion</span>
  <span class="text-[16px] font-bold">Valor publico</span>

  <div class="flex gap-3 items-start">
    <input
      *ngIf="reviewMode && !readonlyReview"
      type="checkbox"
      class="mt-1"
      [checked]="reviewFields.isFieldMarked('publicValueCheck')"
      (change)="reviewFields.toggleField('publicValueCheck')" />
    <div class="flex flex-col gap-2">
      <div class="flex items-start gap-2">
        <span class="text-[14px] text-neutral-dark">Medicion de valor publico</span>
        <app-tooltip
          *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('publicValueCheck')"
          class="-mt-2"
          [description]="previousReviewText('publicValueCheck')"
          tipeIcon="info"></app-tooltip>
      </div>
      <span class="text-[16px] font-regular">
        {{ impactData?.publicValueCheck ? 'Si' : 'No' }}
      </span>
    </div>
  </div>

  <div
    *ngIf="impactData?.publicValueCheck"
    class="flex gap-3 items-start">
    <input
      *ngIf="reviewMode && !readonlyReview"
      type="checkbox"
      class="mt-1"
      [checked]="reviewFields.isFieldMarked('publicValueDescription')"
      (change)="reviewFields.toggleField('publicValueDescription')" />
    <div class="flex flex-col gap-2">
      <div class="flex items-start gap-2">
        <span class="text-[14px] text-neutral-dark">Observaciones</span>
        <app-tooltip
          *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('publicValueDescription')"
          class="-mt-2"
          [description]="previousReviewText('publicValueDescription')"
          tipeIcon="info"></app-tooltip>
      </div>
      <span class="text-[16px] font-regular whitespace-pre-line">
        {{ impactData?.publicValueDescription || '-' }}
      </span>
    </div>
  </div>
</div>
